export class PromiseQueue {
  queue: Promise<unknown>

  constructor() {
    this.queue = Promise.resolve(true)
  }

  add<T>(operation: () => Promise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      this.queue = this.queue.then(operation).then(resolve).catch(reject)
    })
  }
}
